export const CUBI_LOGO_IMG_URI = '/assets/logo-dark.png';
export const CUBI_LOGO_WHITE_IMG_URI = '/assets/logo-white.png';
export const AMBAR_LOGO = '/assets/logo-ambar.png';
export const BC4_LOGO = '/assets/logo-bc4.png';
export const METERS_FILTER_EMPTY_STATE_IMG_URI =
  '/assets/empty-state-meter-filter.svg';
